import { useProjectsStore } from '@modules/projects'
import { useUserStore } from '@modules/user'

import { loadWorkspaceFromStore } from './loadWorkspaceFromStore'

export function isOnboardingAlreadyComplete(): boolean {
  const user = useUserStore.getState().currentUser
  const workspace = loadWorkspaceFromStore()
  const project = useProjectsStore.getState().currentProject

  return Boolean(user && workspace && project)
}
